import React from "react";
import { IconType } from "react-icons";

import IconButton, { IconButtonProps } from "@mui/material/IconButton";

interface Props extends IconButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon: IconType
  iconSize?: number
}

export default function IconButtonComponent({ onClick, icon, iconSize, ...rest }: Props) {
  const Icon = icon;

  return (
    <IconButton onClick={onClick} {...rest}>
      <Icon style={{ fontSize: iconSize }} />
    </IconButton>
  );
}
